var map = {
	"./account-add-file/index.js": 1019,
	"./account-add/index.js": 1020,
	"./account-delete-confirm/index.js": 1021,
	"./account-delete/index.js": 1022,
	"./account-edit/index.js": 1023,
	"./account-onboard/index.js": 1024,
	"./account-remove/index.js": 1025,
	"./account-share-rule/index.js": 1026,
	"./account-share-user/index.js": 1027,
	"./account-share/index.js": 1028,
	"./add-account-navlist/index.js": 1029,
	"./add-dashboard/index.js": 1030,
	"./advanced-settings/index.js": 1031,
	"./change-password/index.js": 1032,
	"./connection-lost/index.js": 1033,
	"./dashboard-created/index.js": 1034,
	"./delete-account-confirmation/index.js": 1035,
	"./delete-account/index.js": 1036,
	"./delete-dashboard/index.js": 1037,
	"./download-backup-key/index.js": 1038,
	"./download-data/index.js": 1039,
	"./drop-account-confirmation/index.js": 1040,
	"./edit-dashboard/index.js": 1041,
	"./email-scan/index.js": 1014,
	"./import-preview/index.js": 1015,
	"./memo-add/index.js": 1042,
	"./modal-dashboards/index.js": 1016,
	"./move-account-dashboard/index.js": 1043,
	"./move-accounts/index.js": 1044,
	"./my-account/index.js": 1045,
	"./offline-msg/index.js": 1046,
	"./password-checkup/index.js": 1047,
	"./prompt-backup-explained/index.js": 1048,
	"./prompt-backup/index.js": 1049,
	"./prompt-tracking/index.js": 1050,
	"./recover-master-key/index.js": 1051,
	"./session-settings/index.js": 1052,
	"./share-dashboard-rules/index.js": 1053,
	"./share-dashboard-user/index.js": 1054,
	"./share-dashboard/index.js": 1055,
	"./sharing-by-invitation/index.js": 1056,
	"./sharing-dashboard-by-invitation/index.js": 1057,
	"./stop-sharing-dashboard/index.js": 1058,
	"./stop-sharing/index.js": 1059,
	"./take-action/index.js": 1009,
	"./take-note-no-dashboard/index.js": 1060,
	"./take-note-private-dashboard-add-accounts/index.js": 1061,
	"./take-note-private-dashboard-move-accounts/index.js": 1062,
	"./template-transfer/index.js": 1017,
	"./unsaved-changes/index.js": 1063,
	"./unsaved-dashboard/index.js": 1064,
	"./user-account-details/index.js": 1065,
	"./welcome-video/index.js": 1066
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 970;